<div class="row">
  <section class="left-side">
    <div class="position">
      <app-info-oc-or-nfe label="QR Code" [value]="position?.qrCode"></app-info-oc-or-nfe>
      <app-info-oc-or-nfe label="Coordenadas" [value]="position?.coords"></app-info-oc-or-nfe>
      <app-info-oc-or-nfe label="Apelido" [value]="position?.alias || '---'"></app-info-oc-or-nfe>
      <div class="buttons">
        <button mat-stroked-button class="alert" *ngIf="isAllowedUser()" (click)="removePigeonhole()">
          Excluir Posição
        </button>
      </div>
    </div>
    <div class="group">
      <app-info-oc-or-nfe label="grupo" [value]="group?.name || '---'"></app-info-oc-or-nfe>
      <app-info-oc-or-nfe label="tipo do grupo" [value]="position?.type || '---'"></app-info-oc-or-nfe>
    </div>
  </section>
</div>
<ng-template #notification>
  <app-notification [data]="notificationData" icon="check-circle"></app-notification>
</ng-template>
